import {myopWebcomponentConsts} from "../../webcomponent/consts";
import {BaseMyopComponent} from "./IMyopComponent";
import {BaseMyopMessage} from "../../messages";
import {CleanupHandler, IComponentDefinitionConfig, ISkinConfig} from "../../common";
import {setDebugStyle} from "../componentCore";
import {loaderOptions} from "../hostSDK";

export class MyopWebComponent extends BaseMyopComponent {

    constructor(componentDefinition: IComponentDefinitionConfig, skin: ISkinConfig, public container: HTMLElement, private customElement: HTMLElement, options?: loaderOptions) {
        super(componentDefinition, container , options);
        this.element = customElement;
    }

    cleanupInspect: CleanupHandler = () => {
    }

    inspect() {
        this.cleanupInspect = setDebugStyle(this.id, 'MyopWebComponent', 0, this.container, this.customElement, this.componentDefinition);
        return this.cleanupInspect;
    }

    hide() {
        this.customElement.style.opacity = '0';
        this.customElement.style.position = 'absolute'
        this.customElement.style.pointerEvents = 'none'
        this.customElement.style.visibility = 'hidden';
        this.customElement.style.height = '0'
        this.customElement.style.width = '0'
    }

    show() {
        this.customElement.style.opacity = '1';
        this.customElement.style.position = 'unset'
        this.customElement.style.pointerEvents = 'all'
        this.customElement.style.visibility = 'visible';
        this.customElement.style.height = '';
        this.customElement.style.width = '';
    }

    send = (message: BaseMyopMessage<any>) => {
        let message_ = {...message} as BaseMyopMessage;

        //TODO : can be done without cloning?
        // @ts-ignore
        //const handler = message_.handler
        const cleanupHandler = super.send(message_);

        const msg = new CustomEvent<BaseMyopMessage>(myopWebcomponentConsts.webcomponent_message_key, {
            // @ts-ignore
            detail: message_,
            // bubbles: true,
            // cancelable: false,
            // composed: true
        })

        //this.container.dispatchEvent(msg)

        //sending data from host to the component
        try {
            this.customElement.dispatchEvent(msg)
            // if (this.customElement.children.length > 0) {
            // } else {
            //     this.customElement.children[0].dispatchEvent(msg)
            // }
        } catch (e) {
            console.log('error while trying to dispatchEvent', e);
        }

        // @ts-ignore
        //message.handler = handler

        return cleanupHandler;
    }

    dispose = () => {
        super.dispose();
        this.customElement.parentNode?.removeChild(this.customElement);
    }
}
